import script from "./DominanceChartView.vue?vue&type=script&setup=true&lang=js"
export * from "./DominanceChartView.vue?vue&type=script&setup=true&lang=js"

import "./DominanceChartView.vue?vue&type=style&index=0&id=470b5549&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-470b5549"]])

export default __exports__